import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import { blue } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Trainee from "../../Images/11.jpg";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import { withStyles } from "@material-ui/core/styles";
import "./ProfileView.css";


import EditIcon from "@material-ui/icons/Edit";
import Patient from "../../Images/1.jpg";
import CloseIcon from "@material-ui/icons/Close";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PerscriptionModal from "./PerscriptionModal";
import axiosInstance from "../../api/axiosInstance";
import dateFormat from "dateformat";
import { apiurl } from "../../App";
import { message } from "antd";
import PrescriptionView from "./PrescriptionView";
const styles = {};

export default class ProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cancel: null, view: false, propsIsFrom: null,openview: false };
  }
  componentWillMount() {
    if (
      (this.props.isFrom === "cancelledDashboard" ||
        this.props.isFrom === "revenueTable") &&
      this.props.isFrom !== this.state.propsIsFrom
    ) {
      this.open();
      this.setState({ propsIsFrom: this.props.isFrom });
    }
  }
  componentWillUpdate() {
    if (
      this.props.open &&
      (this.props.isFrom === "cancelledDashboard" ||
        this.props.isFrom === "revenueTable") &&
      this.props.isFrom !== this.state.propsIsFrom
    ) {
      this.open();
      this.setState({ propsIsFrom: this.props.isFrom });
    }
  }
  handleClose = () => {
    this.props.onClose(this.props.selectedValue);
  };
  open = () => {
    this.setState({ view: true });
  };
  onclose = () => {
    this.setState({ view: false });
    if (
      this.props.isFrom === "cancelledDashboard" ||
      this.props.isFrom === "revenueTable"
    ) {
      this.props.onClose();
      this.setState({ propsIsFrom: null });
    }
  };

  // Send Quote Api
  sendQuote = () => {
    axiosInstance({
      method: "PUT",
      url: apiurl + "pharmacy/updateQuoteSent",
      data: {
        prescription_id: this.props.profileData.prescriptionId,
        pharmacy_id: this.props.profileData.pharmacyId,
        created_on: dateFormat(new Date(), "yyyy-mm-dd"),
      },
    })
      .then((response) => {
        this.props.onClose();
        message.success("Quote Sended Successfully");
        this.props.getTableData(); //props comming from TotalMaster.jsx
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  handlePreviewCloseOpen = () => {
    this.setState({ openview: true })
  };

  
  handlePreviewClose = () => {
    this.setState({ openview: false });
  };

  render() {
    const { profileData } = this.props;
    const { classes, onClose, cancel, selectedValue, ...other } = this.props;
    console.log(profileData)
    return (
      <div className="doctor_popup_details">
        {this.state.view === false && (
          <Dialog
            onClose={this.handleClose}
            aria-labelledby="simple-dialog-title"
            {...other}
            minWidth={"lg"}
            className={"${this.props.change_profile} profile_modal"}
          >
            <div className="close_icon_modal_div">
              <CloseIcon
                className="close_icon_modal totalorder_closeicon"
                onClick={() => this.props.onClose()}
              />
            </div>

            <div className="doctor_details_container">
              <div className="doctor_detailsdiv">
                <div className="patientphar_head">
                  <h3 className="patient_name">{profileData.customer}</h3>
                  <p className="patient_age">
                    {profileData.age + " Years - "}
                    {profileData.gender}
                  </p>
                  <p className="patientappointment_details-div">
                    Order Details
                  </p>
                </div>

                <div className="patientappointment_details">
                  <p className="patientappointment_details">Doctor Name</p>
                  <span className="patient_date">{profileData.doctorName}</span>
                </div>
                {/* <div className="patientappointment_details"><p className="patientappointment_details">Civil Id</p><span className="patient_date">{profileData.civilId !== null ? profileData.civilId : "-"}</span></div> */}
                {/* <div className="patientappointment_details"><p className="patientappointment_details">Insurance</p><span className="patient_date">{profileData.insuranceNumber !== null ? profileData.insuranceNumber: "-"}</span></div> */}
                <div className="patientappointment_details">
                  <p className="patientappointment_details">Quoted</p>
                  <span className="patient_date">
                    {profileData.quoted_amount
                      ? `${profileData.quoted_amount} INR`
                      : "0 INR"}
                  </span>
                </div>
                <div className="patientappointment_details">
                  <p className="patientappointment_details">Approved</p>
                  <span className="patient_date">
                    {profileData.approved_amount
                      ? `${profileData.approved_amount} INR`
                      : "0 INR"}
                  </span>
                </div>
                <div className="patientappointment_details">
                  <p className="patientappointment_details">Deleted</p>
                  <span className="patient_date">
                    {profileData.deleted_amount
                      ? `${profileData.deleted_amount} INR`
                      : "0 INR"}
                  </span>
                </div>
                <div className="patientappointment_details">
                  <p className="patientappointment_details">Billed</p>
                  <span className="patient_date">
                    {profileData.billed_amount
                      ? `${profileData.billed_amount} INR`
                      : "0 INR"}
                  </span>
                </div>
                {/* <div className="patientappointment_details"><p className="patientappointment_details">Insurance Approved</p><span className="patient_date">0 INR</span></div> */}
                {/* <div className="patientappointment_details">
                  <p className="patientappointment_details">Balance</p>
                  <span className="patient_date">{`${profileData.totalAmount} INR`}</span>
                </div> */}

                <Divider className="divider_root" />
                <div className="patientappointment_view">
                  {profileData.isEnablePopup === "true" && (
                    <div className="pres_eye">
                      <p className="view_text" onClick={this.open}>
                        Prescription
                      </p>{" "}
                      <span>
                        <VisibilityIcon
                          className="view_icon"
                          onClick={this.handlePreviewCloseOpen}
                        />
                      </span>
                    </div>
                  )}
                  {profileData.statusId === 1 && (
                    <div>
                      <Button
                        variant="contained"
                        className="view_detailsbutton"
                        onClick={() => this.sendQuote()}
                      >
                        Send Quote
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Dialog>
        )}

        {console.log(
          "profileData.prescriptionId",
          profileData.prescriptionId,
          profileData.pharmacyId
        )}
        <PerscriptionModal
          open={this.state.view}
          onClose={this.onclose}
          prescriptionId={profileData.prescriptionId}
          pharmacyId={profileData.pharmacyId}
          isFrom={this.props.isFrom}
        />

                
        <PrescriptionView
          open={this.state.openview}
          onClose={this.handlePreviewClose}
          xswidth={"xs"}
          fileName={profileData.prescript_file_path}
        />
                
      </div>
    );
  }
}
const Trainer_viewWrapped = withStyles(styles)(ProfileView);
